import { render, staticRenderFns } from "./HistorialPaymentIndex.vue?vue&type=template&id=142d1b9c"
import script from "./HistorialPaymentIndex.vue?vue&type=script&lang=js"
export * from "./HistorialPaymentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports